import { NavBar } from './landing/NavBar';
import { HeroSection } from './landing/HeroSection';
import { FeaturesSection } from './landing/FeaturesSection';
import { DemoSection } from './landing/DemoSection';
import { TestimonialsSection } from './landing/TestimonialsSection';
import { AboutSection } from './landing/AboutSection';
import { CtaSection } from './landing/CtaSection';
import { ContactSection } from './landing/ContactSection';
import { Footer } from './landing/Footer';

export const LandingPage = ({ onGetStarted }) => {
  return (
    <div className="min-h-screen bg-white">
      <NavBar onGetStarted={onGetStarted} />
      <HeroSection onGetStarted={onGetStarted} />
      <FeaturesSection />
      <DemoSection />
      <TestimonialsSection onGetStarted={onGetStarted} />
      <AboutSection onGetStarted={onGetStarted} />
      <CtaSection onGetStarted={onGetStarted} />
      <ContactSection />
      <Footer />
    </div>
  );
};
